export function formatCurrency(amount, currency = 'USD') {
    // Use toLocaleString() to format the number as currency
    return amount.toLocaleString('en-US', {
      style: 'currency',
      currency: currency,
    });
  }
  